import {initItemcardImages} from "../../../default/global/js/itemcardImages";
import {initRatingStars} from "../../../default/global/js/rating";
import {triggerCopyLink} from "../../../default/global/js/copyToClipboard";
import {itemcardSubscriptions} from "../../../default/global/js/subscriptions";
import {shareItemcardModal} from "../../../default/global/js/shareItemcard";
import {initVariantSelectionSlider} from "../../../default/global/js/variantSelectionSlider";
// import {init360Images} from "../../../default/global/js/init360Images";
import {openFullscreenGallery} from "../../../default/global/js/fullscreengallery";

window.addEventListener("load", (event) => {
    initItemcardImages();
    initRatingStars();
    triggerCopyLink();
    itemcardSubscriptions();
    shareItemcardModal();
    initVariantSelectionSlider();

    let i =  0;
    for (const item of document.querySelectorAll(".js-itemcardOpenGallery")) {
        if(!item.dataset.index){
            item.setAttribute("data-index",i);
        }
        item.addEventListener('click', function (event) {
            openFullscreenGallery(item,".js-itemcardOpenGalleryItem");
        });
        i++;
    }
});